import React from "react";
import Icon from "react-icon-base";

function GAssistantIcon(props) {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <g>
        <circle cx="156.268" cy="167.705" fill="#4285F4" r="156.268" />
        <path d="M512,182.95c0,17.544-14.224,31.762-31.762,31.762s-31.762-14.218-31.762-31.762   c0-17.543,14.224-31.762,31.762-31.762S512,165.407,512,182.95z" fill="#34A853" />
		    <path d="M454.829,260.449c0,35.081-28.438,63.522-63.523,63.522c-35.088,0-63.524-28.441-63.524-63.522   c0-35.083,28.437-63.524,63.524-63.524C426.392,196.925,454.829,225.367,454.829,260.449z" fill="#EA4335" />
		    <path d="M467.533,424.339c0,42.1-34.124,76.225-76.228,76.225c-42.104,0-76.229-34.125-76.229-76.225   c0-42.098,34.124-76.227,76.229-76.227C433.409,348.112,467.533,382.241,467.533,424.339z" fill="#FBBC05" />
	    </g>
    </Icon>
  );
}

export default GAssistantIcon;



// WEBPACK FOOTER //
// ./src/static/GAssistantIcon.js